import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Cars24Login() {
  // State variables to store form data
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loginType, setLoginType] = useState("email"); // Can be 'email' or 'phone'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // API endpoint
  const API_BASE = "http://192.168.29.147:5000/api/auth/user";

  // Function to handle form submission
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent page refresh

    // Set loading state to true
    setLoading(true);
    setError(""); // Clear any previous errors

    try {
      // Prepare data to send to server
      const loginData = loginType === "email" ? { email } : { phoneNumber };

      // Make API call using axios (this is the simplified version for demonstration)
      // In your actual project, you would use:
      // const response = await axios.post(`${API_BASE}/login`, loginData);
      // console.log(response);

      // Simulating API call for demo
      // console.log("Would send this data:", loginData);
      // console.log("To endpoint:", `${API_BASE}/login`);

      // Simulate successful response
      // setTimeout(() => {
      //   alert(`OTP would be sent to your ${loginType}`);
      //   setLoading(false);
      // }, 2000);

      // In real implementation with axios:

      const response = await axios.post(`${API_BASE}/login`, loginData);

      console.log("Login response:", response.data);

      //  Navigate to OTP page (you'd use react-router-dom's navigate)
      if (response.data) {
        navigate("/user-otp", {
          state: {
            loginType,
            email: loginType === "email" ? email : null,
            phoneNumber: loginType === "phone" ? phoneNumber : null,
          },
        });
      }
    } catch (err) {
      // Handle different types of errors
      console.log("Login error:", err);

      // With axios, error handling is cleaner:
      if (err.response) {
        // Server responded with error status (4xx, 5xx)
        setError(err.response.data.message || "Login failed");
      } else if (err.request) {
        // Request was made but no response received (network error)
        setError("Network error. Please check your connection.");
      } else {
        // Something else went wrong
        setError("Something went wrong. Please try again.");
      }

      setLoading(false);
      
    }
  };
  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      navigate("/booking/add/:id");
    }
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          {/* Logo and branding */}
          <div className="flex items-center justify-center space-x-3 mb-8">
            <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl flex items-center justify-center">
              <div className="text-white text-xl font-bold">🚗</div>
            </div>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
              Cars24
            </h1>
          </div>

          {/* Welcome Message */}
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-amber-600 mb-2">
              Welcome Back!
            </h2>
            <p className="text-amber-700">Sign in to access your account</p>
          </div>

          {/* Toggle between Email and Phone login */}
          <div className="flex bg-gray-100 rounded-lg p-1 mb-6">
            <button
              onClick={() => setLoginType("email")}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all flex items-center justify-center space-x-2 ${
                loginType === "email"
                  ? "bg-white text-orange-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              <div className="text-lg">📧</div>
              <span>Email</span>
            </button>
            <button
              onClick={() => setLoginType("phone")}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-all flex items-center justify-center space-x-2 ${
                loginType === "phone"
                  ? "bg-white text-orange-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              <div className="text-lg">📱</div>
              <span>Phone</span>
            </button>
          </div>

          {/* Login Form */}
          <div className="space-y-6">
            {/* Input Field - Changes based on login type */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {loginType === "email" ? "Email Address" : "Phone Number"}
              </label>
              <div className="relative">
                {/* Icon inside input field */}
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  {loginType === "email" ? (
                    <div className="text-lg">📧</div>
                  ) : (
                    <div className="text-lg">📱</div>
                  )}
                </div>

                {/* Input field */}
                <input
                  type={loginType === "email" ? "email" : "tel"}
                  value={loginType === "email" ? email : phoneNumber}
                  onChange={(e) => {
                    // Update the correct state based on login type
                    if (loginType === "email") {
                      setEmail(e.target.value);
                    } else {
                      setPhoneNumber(e.target.value);
                    }
                  }}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all"
                  placeholder={
                    loginType === "email"
                      ? "Enter your email"
                      : "Enter your phone number"
                  }
                  required
                />
              </div>
            </div>

            {/* Error Message - Only shows if there's an error */}
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            )}

            {/* Submit Button */}
            <button
              onClick={handleLogin}
              disabled={loading}
              className="w-full bg-gradient-to-r from-amber-500 to-red-500 text-white py-3 px-4 rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transform hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
              {loading ? (
                // Loading spinner
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <span>Send OTP</span>
              )}
            </button>
          </div>
        </div>

        {/* Terms and Privacy links */}
      </div>
    </div>
  );
}
